import styled from 'styled-components';

export const ProfileImg = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
`;
